export const getMissionsList = ({ missionList: { missionsList } }) => {
  if (!missionsList) {
    return []
  }

  return missionsList
}
